import { Button, Col, Row, Modal, ModalBody, Label, Input, Form, FormGroup, CardBody, Card } from "reactstrap";
import React, { useState, useEffect } from "react";
import { create, uploadImage, getAllImage } from "../../api/apiBlog";
import { convertBase64 } from "../../common/constants/Services";
import Select from 'react-select';
import ImageDefault from "../../assets/images/featured-job/img-default.webp"
import SunEditor from "suneditor-react";
import "suneditor/dist/css/suneditor.min.css";
import { createSlug } from "../../common/constants/Services";


const AddEdit = (props) => {
    let [isOpen, setIsOpen] = useState(false);
    let [onClose, setOnClose] = useState(() => { });
    let [onSave, setOnSave] = useState(() => { });
    let [postTitle, setPostTitle] = useState("");
    let [postContent, setPostContent] = useState("");
    let [postCategory, setPostCategory] = useState(null);
    let [postId, setPostId] = useState(0);
    let [image, setImage] = useState(null);
    let [base64File, setBase64File] = useState(null);
    let [imageUrlArr, setImageUrlArr] = useState([]);
    let [titleSeo, setTitleSeo] = useState("");
    let [permaLink, setPermaLink] = useState("");
    let [description, setDescription] = useState("");
    let [titleImage, setTitleImage] = useState("");
    let [descriptionImage, setDescriptionImage] = useState("");
    let [tagAlt, setTagAlt] = useState("");

    useEffect(() => {
        if (props) {
            props.isOpen ? setIsOpen(true) : setIsOpen(false);
            if (props.onClose) {
                setOnClose(() => () => props.onClose());
            }
            if (props.onSave) {
                setOnSave(() => () => props.onSave());
            }
            if (props.currentPost) {
                setPostTitle(props.currentPost.title);
                setPostContent(props.currentPost.content);
                props.currentPost.seoTitle ? setTitleSeo(props.currentPost.seoTitle) : setTitleSeo(props.currentPost.title);
                props.currentPost.seoUrl ? setPermaLink(props.currentPost.seoUrl) : setPermaLink(createSlug(props.currentPost.title));
                setDescription(props.currentPost.seoDescription);
                props.currentPost.thumnailTitle ? setTitleImage(props.currentPost.thumnailTitle) : setTitleImage("");
                props.currentPost.thumnailDescription ? setDescriptionImage(props.currentPost.thumnailDescription) : setDescriptionImage("");
                props.currentPost.thumbnailAlt ? setTagAlt(props.currentPost.thumbnailAlt) : setTagAlt("");
                setPostId(props.currentPost.id);
                setImage(props.currentPost.image);
                setPostCategory(null);
                for (let item of props.categoryList) {
                    if (item.value === props.currentPost.categoryId) {
                        setPostCategory(item);
                        break;
                    }
                }
            } else {
                setPostTitle("");
                setPostContent("");
                setTitleSeo("");
                setTitleImage("");
                setDescriptionImage("");
                setTagAlt("")
                setPermaLink("");
                setDescription("");
                setPostId(0);
                setImage(null);
                setBase64File(null);
                setPostCategory(0);
            }
        }
        getImageGallery();
    }, [props]);

    const getImageGallery = () => {
        getAllImage().then((res) => {
            if (res) {
                let urlArr = [];
                res.map((item) => {
                    let imageName = item.split('/');
                    urlArr.push({ src: item, name: imageName[4] })
                })
                setImageUrlArr(urlArr);
            }
        })
    }

    const ChangeTitle = (e) => {
        setPostTitle(e.target.value);
    };

    const handleEditorChange = content => {
        setPostContent(content);
    };

    const chooseCategory = (e) => {
        setPostCategory(e);
    }

    const handleUploadImage = async event => {
        const bannerLoaded = URL.createObjectURL(event.target.files[0]);
        const base64 = await convertBase64(event.target.files[0]);
        let base64Data = base64.split(',');
        setBase64File(base64Data[1]);
        setImage(bannerLoaded);
    }

    const Save = () => {
        let data = {
            id: postId,
            title: postTitle,
            content: postContent,
            image: image,
            seoUrl: permaLink,
            seoDescription: description,
            seoTitle: titleSeo,
            thumnailTitle: titleImage,
            thumnailDescription: descriptionImage,
            thumbnailAlt: tagAlt,
            base64File: base64File,
            categoryId: postCategory.value
        }

        create(data).then((res) => {
            if (res && res) {
                if (res.status) {
                    onSave();
                    onClose();
                } else {
                    alert("Lưu thất bại");
                }
            }
        });
    }

    const handleImageUploadBefore = async (files, info, uploadHandler) => {
        if (files) {
            await uploadImage(files[0]).then((res) => {
                if (res) {
                    const response = {
                        result: [
                            {
                                url: res,
                                name: files[0].name,
                            }
                        ]
                    }
                    uploadHandler(response);
                    getImageGallery();
                }
            })
        }
    }

    const handleOnChange = (event) => {
        if (event.target.value) {
            document.querySelectorAll('.__se__img_name').forEach((item, key) => {
                let data = item.textContent.toLowerCase().includes(event.target.value.toLowerCase());
                if (data) {
                    item.parentElement.style.display = 'block';
                } else {
                    item.parentElement.style.display = 'none';
                }
            })
        } else {
            document.querySelectorAll('.__se__img_name').forEach((item, key) => {
                item.parentElement.style.display = 'block';
            })
        }
    }

    const handleOnload = () => {
        document.querySelectorAll('.se-btn.se-tooltip').forEach((item, key) => {
            if (item.getAttribute('aria-label') == 'Image gallery') {
                item.addEventListener('click', function () {
                    setTimeout(() => {
                        if (!document.querySelector('.input-search')) {
                            const divEle = document.querySelector('.se-file-browser-header');
                            const wrapper = document.createElement("div");
                            const iFeild = document.createElement("input");
                            iFeild.setAttribute("type", "text");
                            iFeild.setAttribute("placeholder", "Tìm kiếm ảnh...");
                            iFeild.setAttribute("style", "height: 30px; width: 400px");
                            iFeild.classList.add("input-search");
                            wrapper.appendChild(iFeild);
                            divEle.appendChild(wrapper);

                            document.querySelector('.input-search').addEventListener('change', (event) => {
                                handleOnChange(event);
                            });
                        }
                    }, 1000);
                });
            }
        });
    }

    const handleTitleSeo = (event) => {
        setTitleSeo(event.target.value);
    }

    const handlePermaLink = (event) => {
        setPermaLink(event.target.value);
    }

    const handleDescription = (event) => {
        setDescription(event.target.value);
    }

    const handleTitleImage = (event) => {
        setTitleImage(event.target.value);
    }

    const handleDescriptionImage = (event) => {
        setDescriptionImage(event.target.value);
    }

    const handleTagAlt = (event) => {
        setTagAlt(event.target.value);
    }

    return (
        <React.Fragment>
            <Modal isOpen={isOpen} role="dialog" centered fullscreen
                backdrop="static"
                scrollable={true}
            >
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title mt-0">
                            {props.title ? props.title : ""}
                        </h5>
                        <button
                            type="button"
                            className="btn-close"
                            onClick={() => onClose()}
                        ></button>
                    </div>
                    <ModalBody>
                        <Row>
                            <Col lg={12}>
                                <Card>
                                    <CardBody>
                                        <Form>
                                            <Row>
                                                <Col lg={4}>
                                                    <FormGroup className="mb-4">
                                                        <Label for="basicpill-firstname-input">Ảnh </Label>
                                                        <div className="mb-4 profile-user">
                                                            <img
                                                                src={image ? image : ImageDefault}
                                                                className="rounded-3 img-thumbnail"
                                                                id="profile-img"
                                                                alt=""
                                                                style={{ maxHeight: "200px" }}
                                                            />
                                                            <div className="p-0 rounded-3 profile-photo-edit">
                                                                <Input
                                                                    id="profile-img-file-input"
                                                                    type="file"
                                                                    className="profile-img-file-input"
                                                                    onChange={handleUploadImage}
                                                                />
                                                                <Label
                                                                    htmlFor="profile-img-file-input"
                                                                    className="profile-photo-edit avatar-xs"
                                                                >
                                                                    <i className="uil uil-edit"></i>
                                                                </Label>
                                                            </div>
                                                        </div>
                                                    </FormGroup>
                                                </Col>
                                                <Col lg={8}>
                                                    <FormGroup className="mb-4">
                                                        <Label for="basicpill-category-input">Tiêu đề ảnh</Label>
                                                        <Input type="text" className="form-control" id="title-image" onChange={handleTitleImage} value={titleImage} />
                                                    </FormGroup>
                                                    <FormGroup className="mb-4">
                                                        <Label for="basicpill-category-input">Thẻ mô tả ảnh</Label>
                                                        <Input type="text" className="form-control" id="description-image" onChange={handleDescriptionImage} value={descriptionImage} />
                                                    </FormGroup>
                                                    <FormGroup className="mb-4">
                                                        <Label for="basicpill-category-input">Thẻ alt</Label>
                                                        <Input type="text" className="form-control" id="tag-alt" onChange={handleTagAlt} value={tagAlt} />
                                                    </FormGroup>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col lg={12}>
                                                    <FormGroup className="mb-4">
                                                        <Label for="basicpill-category-input">Danh mục</Label>
                                                        <Select
                                                            isMulti={false}
                                                            options={props.categoryList}
                                                            value={postCategory}
                                                            onChange={chooseCategory}
                                                            styles={{
                                                                control: (baseStyles) => ({
                                                                    ...baseStyles,
                                                                    backgroundColor: "#ffffff",
                                                                    borderColor: '#eff0f2',
                                                                    height: '42.6px',
                                                                    fontWeight: 500,
                                                                    paddingLeft: 40
                                                                }),
                                                            }}
                                                            className="react-select-container"
                                                            classNamePrefix="react-select"
                                                        />
                                                    </FormGroup>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col lg={12}>
                                                    <FormGroup className="mb-4">
                                                        <Label for="basicpill-category-input">Tiêu đề SEO</Label>
                                                        <Input type="text" className="form-control" id="title-seo" onChange={handleTitleSeo} value={titleSeo} />
                                                    </FormGroup>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col lg={12}>
                                                    <FormGroup className="mb-4">
                                                        <Label for="basicpill-category-input">Liên kết cố định</Label>
                                                        <Input type="text" className="form-control" id="perma-link" onChange={handlePermaLink} value={permaLink} />
                                                    </FormGroup>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col lg={12}>
                                                    <FormGroup className="mb-4">
                                                        <Label for="basicpill-category-input">Thẻ mô tả</Label>
                                                        <textarea
                                                            style={{ height: '150px' }}
                                                            type="text"
                                                            className="form-control"
                                                            id="description"
                                                            onChange={handleDescription}
                                                            value={description}
                                                        />
                                                    </FormGroup>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col lg={12}>
                                                    <FormGroup className="mb-4">
                                                        <Label for="basicpill-title-input">Tiêu đề</Label>
                                                        <Input type="text" className="form-control" id="basicpill-title-input" defaultValue={postTitle} onChange={ChangeTitle} />
                                                    </FormGroup>
                                                    <FormGroup className="mb-4">
                                                        <Label for="basicpill-content-input">Nội dung</Label>
                                                        <SunEditor
                                                            setContents={postContent}
                                                            showToolbar={false}
                                                            onChange={handleEditorChange}
                                                            onImageUploadBefore={handleImageUploadBefore}
                                                            onLoad={handleOnload}
                                                            setDefaultStyle="height: 400px; font-size: 15px"
                                                            setOptions={{
                                                                buttonList: [
                                                                    ["undo", "redo"],
                                                                    ["font", "fontSize", "formatBlock"],
                                                                    ["bold", "underline", "italic", "strike", "subscript", "superscript"],
                                                                    ["removeFormat"],
                                                                    "/",
                                                                    ["fontColor", "hiliteColor"],
                                                                    ["outdent", "indent"],
                                                                    ["align", "horizontalRule", "list", "table"],
                                                                    ["link", "image", "video"],
                                                                    ["imageGallery"],
                                                                    ["fullScreen", "showBlocks", "codeView"],
                                                                    ["preview", "print"],
                                                                ],
                                                                imageGalleryData: imageUrlArr,
                                                                formats: ["p", "div", "h1", "h2", "h3", "h4", "h5", "h6"],
                                                                font: [
                                                                    "Arial",
                                                                    "Calibri",
                                                                    "Comic Sans",
                                                                    "Courier",
                                                                    "Garamond",
                                                                    "Georgia",
                                                                    "Impact",
                                                                    "Lucida Console",
                                                                    "Palatino Linotype",
                                                                    "Segoe UI",
                                                                    "Tahoma",
                                                                    "Times New Roman",
                                                                    "Trebuchet MS"
                                                                ]
                                                            }}
                                                        />
                                                    </FormGroup>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col lg={12}>
                                                    <Button type="button" color="secondary" className="me-1" onClick={() => onClose()} >Hủy</Button>
                                                    <Button type="button" color="primary" onClick={() => Save()} >Lưu</Button>
                                                </Col>
                                            </Row>
                                        </Form>
                                    </CardBody>
                                </Card>
                            </Col>
                        </Row>
                    </ModalBody>
                </div>
            </Modal>
        </React.Fragment>
    );
}

export default AddEdit;